export const state = {
  words: [],
  isLoading: false,
  pagination: null,
};
